import React from 'react';

function box(props) {
  if (props.type === 'plain-gray') {
    return (
      <div className="text-gray-300 bg-neutral-800 rounded-xl border border-tundora">
        {props.children}
      </div>
    );
  }

  if (props.type === 'gray') {
    return (
      <div className="text-gray-300 bg-gray-900 border-t-2 border-gray-700 rounded-xl">
        {props.children}
      </div>
    );
  }

  if (props.type === 'bordered-gray') {
    return <div className="bg-gray-900 rounded-xl border border-tundora">{props.children}</div>;
  }

  // Gradient
  return (
    <div className="h-full rounded-xl relative overflow-hidden pb-[4px]">
      <div className="h-full text-gray-300 bg-gray-900">{props.children}</div>
      <div className="h-[4px] w-full bg-gradient-x absolute bottom-0" />
    </div>
  );
}

box.defaultProps = {
  type: 'gray'
};

export default box;
